import React from 'react'
import Title from '../shared/Title'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import styles from './_victoryStory.css'
import outrunningAddiction from 'images/app-page/victory-stories/outrunning-addiction.png'
import sam from 'images/app-page/victory-stories/sam.png'

function VictoryStories () {

  return (
    <div className={styles.victoryStories}>
      <Title align="center">
        <FormattedMessage id='appPage.victoryStories.title' defaultMessage='Victory Stories' />
      </Title>
      <ul className={styles.stories}>
        <VictoryStory image={sam} href={'http://blog.myfitnesspal.com/sam-decided-run-1000-miles-stroller/'}>
          <FormattedMessage id='appPage.victoryStories.samStory' defaultMessage='Why Sam Decided to Run 1,000 Miles With a Stroller' />
        </VictoryStory>

        <VictoryStory image={outrunningAddiction} href='http://blog.myfitnesspal.com/outrunning-addiction-challenge-brians-sister-helped-kick-cigarettes/'>
          <FormattedMessage id='appPage.victoryStories.outrunningAddiction' defaultMessage='Outrunning Addiction: How a Challenge From Brian’s Sister Helped Him Kick Cigarettes' />
        </VictoryStory>
      </ul>
    </div>
  )
}

function VictoryStory (props) {
  const { image, children, href } = props
  return (
    <li className={styles.story}>
      <a target='_blank' rel='noopener noreferrer' href={href}>
        <img className={styles.storyImage} src={image} />
        <h3 className={styles.storyTitle}>{children}</h3>
      </a>
    </li>
  )
}

VictoryStory.propTypes = {
  image: PropTypes.string,
  href: PropTypes.string,
  children: PropTypes.object,
}

export default VictoryStories



// WEBPACK FOOTER //
// ./src/components/app-page/victory-stories/index.jsx